import { defineModel, serializable } from '../model'

class FavoriteTechnicArticle {
    @serializable()
    technicArticle: ApiModel<'TechnicArticle'>

    @serializable()
    id: number
}

export default defineModel(FavoriteTechnicArticle)
